import React, { useState, useEffect } from 'react';
import { bool, func, object, number, string } from 'prop-types';
import classNames from 'classnames';
import logo from '../../../../assets/logo_header.png';
import logoNew from '../../../../assets/NewLogos/Layer_1.svg';
import logoLandingPage from '../../../../assets/logoLandingPage.png';
import logoLandingPageNew from '../../../../assets/NewLogos/LOGO-orangebg.svg';

import { FormattedMessage, intlShape } from '../../../../util/reactIntl';
import { ACCOUNT_SETTINGS_PAGES } from '../../../../routing/routeConfiguration';
import { propTypes } from '../../../../util/types';
import {
  Avatar,
  InlineTextButton,
  LinkedLogo,
  Menu,
  MenuLabel,
  MenuContent,
  MenuItem,
  NamedLink,
} from '../../../../components';
import { FaRegHeart } from 'react-icons/fa';

import TopbarSearchForm from '../TopbarSearchForm/TopbarSearchForm';
import CustomLinksMenu from './CustomLinksMenu/CustomLinksMenu';

import css from './TopbarDesktop.module.css';

const InboxLink = ({ notificationCount, currentUserHasListings, isLandingpage, isScrolled }) => {
  const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;

  const backgroundClass = isLandingpage && !isScrolled ? css.orangeBackground : css.blackBackground;
  return (
    <NamedLink
      className={classNames(css.topbarLinkInbox, backgroundClass)}
      name="InboxPage"
      params={{ tab: currentUserHasListings ? 'sales' : 'orders' }}
    >
      <span className={css.topbarLinkLabelInbox}>
        {/* <FormattedMessage id="TopbarDesktop.inbox" /> */}
        My Dashboard
        {notificationDot}
      </span>
    </NamedLink>
  );
};

const ProfileMenu = ({ currentPage, currentUser, onLogout }) => {
  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
  };

  return (
    <Menu>
      <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
        <Avatar className={css.avatar} user={currentUser} disableProfileLink />
      </MenuLabel>
      <MenuContent className={css.profileMenuContent}>
        <MenuItem key="ManageListingsPage">
          <NamedLink
            className={classNames(css.menuLink, currentPageClass('ManageListingsPage'))}
            name="ManageListingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.yourListingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="ProfileSettingsPage">
          <NamedLink
            className={classNames(css.menuLink, currentPageClass('ProfileSettingsPage'))}
            name="ProfileSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="AccountSettingsPage">
          <NamedLink
            className={classNames(css.menuLink, currentPageClass('AccountSettingsPage'))}
            name="AccountSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.accountSettingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="logout">
          <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.logout" />
          </InlineTextButton>
        </MenuItem>
      </MenuContent>
    </Menu>
  );
};

const TopbarDesktop = props => {
  const {
    className,
    config,
    customLinks,
    currentUser,
    currentPage,
    rootClassName,
    currentUserHasListings,
    notificationCount,
    intl,
    isAuthenticated,
    onLogout,
    onSearchSubmit,
    initialSearchFormValues,
  } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [mounted, setMounted] = useState(false);
  const isLandingpage = currentPage === 'LandingPage';
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isLandingpage]);

  const SignupLink = () => {
    return (
      <NamedLink name="SignupPage" className={css.topbarLink}>
        <span className={css.topbarLinkLabel}>
          <FormattedMessage id="TopbarDesktop.signup" />
        </span>
      </NamedLink>
    );
  };

  const LoginLink = ({ isLandingpage, isScrolled }) => {
    const backgroundClass =
      isLandingpage && !isScrolled ? css.orangeBackground : css.blackBackground;
    return (
      <NamedLink name="LoginPage" className={classNames(css.topbarLinkInboxNew, backgroundClass)}>
        <span className={css.topbarLinkLabelLoginNew} >
          <FormattedMessage id="TopbarDesktop.login" />
        </span>
      </NamedLink>
    );
  };
   const SignupLinkNew = ({ isLandingpage, isScrolled }) => {
    const backgroundClass =
      isLandingpage && !isScrolled ? css.orangeBackground : css.blackBackground;
    return (
      <NamedLink name="SignupPage" className={classNames(css.topbarLinkInboxNew, backgroundClass)}>
        <span className={css.topbarLinkLabelLoginNew}>
          <FormattedMessage id="TopbarDesktop.signup" />
        </span>
      </NamedLink>
    );
  };

  const blogLink = (
    <NamedLink
      name="BlogPostsPage"
      className={css.topbarLink}
      // className={false ? css.inboxLinklandingPage : css.inboxLink}
    >
      <span className={css.topbarLinkLabel}>
        <FormattedMessage id="TopbarDesktop.BlogLink" />
      </span>
    </NamedLink>
  );
  const profileLink = (
    <NamedLink
      name="ProfileSettingsPage"
      className={css.topbarLink}
    >
      <span className={css.topbarLinkLabel}>
        <FormattedMessage id="TopbarDesktop.profileLink" />
      </span>
    </NamedLink>
  );
  const aboutUs = (
    <NamedLink
      name="AboutUsPage"
      className={css.topbarLink}
      // className={false ? css.inboxLinklandingPage : css.inboxLink}
    >
      <span className={css.topbarLinkLabel}>
        <FormattedMessage id="TopbarDesktop.AboutLink" />
      </span>
    </NamedLink>
  );
  const shop = (
    <NamedLink
      name="ShopUsPage"
      className={css.topbarLink}
      // className={false ? css.inboxLinklandingPage : css.inboxLink}
    >
      <span className={css.topbarLinkLabel}>
        <FormattedMessage id="TopbarDesktop.shopLink" />
      </span>
    </NamedLink>
  );

  const faq = (
    <NamedLink
      name="FaqPage"
      className={css.topbarLink}
      // className={false ? css.inboxLinklandingPage : css.inboxLink}
    >
      <span className={css.topbarLinkLabel}>
        <FormattedMessage id="TopbarDesktop.FaqLink" />
      </span>
    </NamedLink>
  );
  // const shop = (
  //   <NamedLink
  //     name="SearchPage"
  //     className={css.topbarLink}
  //     // className={false ? css.inboxLinklandingPage : css.inboxLink}
  //   >
  //     <span className={css.topbarLinkLabel}>
  //       <FormattedMessage id="TopbarDesktop.shopLink" />
  //     </span>
  //   </NamedLink>
  // );
    const home = (
    <NamedLink
      name="LandingPage"
      className={css.topbarLink}
      // className={false ? css.inboxLinklandingPage : css.inboxLink}
    >
      <span className={css.topbarLinkLabel}>
        <FormattedMessage id="TopbarDesktop.LandingPageLink" />
      </span>
    </NamedLink>
  );
  const sell = (
    <NamedLink
      name="SelectCategoryPage"
      className={css.topbarLink}
      // className={false ? css.inboxLinklandingPage : css.inboxLink}
    >
      <span className={css.topbarLinkLabel}>
        <FormattedMessage id="TopbarDesktop.sellLink" />
      </span>
    </NamedLink>
  );

  const marketplaceName = config.marketplaceName;
  const authenticatedOnClientSide = mounted && isAuthenticated;
  const isAuthenticatedOrJustHydrated = isAuthenticated || !mounted;

  const giveSpaceForSearch = customLinks == null || customLinks?.length === 0;

  const classes = classNames(
    rootClassName ||
      (isLandingpage ? (isScrolled ? css.rootLandingOrange : css.rootLanding) : css.root),
    className
  );

  const inboxLinkMaybe = authenticatedOnClientSide ? (
    <InboxLink
      notificationCount={notificationCount}
      currentUserHasListings={currentUserHasListings}
      isLandingpage={isLandingpage}
      isScrolled={isScrolled}
    />
  ) : null;

  const profileMenuMaybe = authenticatedOnClientSide ? (
    <ProfileMenu currentPage={currentPage} currentUser={currentUser} onLogout={onLogout} />
  ) : null;

  const signupLinkMaybe = isAuthenticatedOrJustHydrated ? null : <SignupLink />;
  const loginLinkMaybe = isAuthenticatedOrJustHydrated ? null : (<>
    <LoginLink isLandingpage={isLandingpage} isScrolled={isScrolled} />
  </>);
   const signupLinkMaybeNew = isAuthenticatedOrJustHydrated ? null : (<>
    <SignupLinkNew isLandingpage={isLandingpage} isScrolled={isScrolled} />
  </>);

  return (
    <nav className={classes}>
      <div className={css.flexContainerOne}>
      {home}
        {sell}
        {shop}

        {faq}
        {/* {currentUser ? (
          <NamedLink className={css.createListingLink} name="WishlistPage">
            <span className={css.createListing}>
              <FaRegHeart className={css.heartIcon} />
            </span>
          </NamedLink>
        ) : null} */}
      </div>

      <NamedLink name="LandingPage" className={css.topbarLink}>
        <img
          className={`${css.logoLink} ${
            isLandingpage ? (isScrolled ? css.logoVisible : css.logoHidden) : css.logoVisible
          }`}
          src={logoLandingPageNew}
          alt="logo"
        />
        <img
          className={`${css.logoLink} ${
            isLandingpage ? (isScrolled ? css.logoHidden : css.logoVisible) : css.logoHidden
          }`}
          src={logoNew}
          alt="logo"
        />
      </NamedLink>

      <div className={css.flexContainerTwo}>
        {authenticatedOnClientSide ? profileLink : null}
        {aboutUs}
        {isAuthenticated ? inboxLinkMaybe : <div className={css.authLinksContainer}>{loginLinkMaybe}{signupLinkMaybeNew}</div>}
      </div>
    </nav>
  );
};

TopbarDesktop.defaultProps = {
  rootClassName: null,
  className: null,
  currentUser: null,
  currentPage: null,
  notificationCount: 0,
  initialSearchFormValues: {},
  config: null,
};

TopbarDesktop.propTypes = {
  rootClassName: string,
  className: string,
  currentUserHasListings: bool.isRequired,
  currentUser: propTypes.currentUser,
  currentPage: string,
  isAuthenticated: bool.isRequired,
  onLogout: func.isRequired,
  notificationCount: number,
  onSearchSubmit: func.isRequired,
  initialSearchFormValues: object,
  intl: intlShape.isRequired,
  config: object,
};

export default TopbarDesktop;
